import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, TabGroup, TabItem, Typography } from '@saviynt/design-system';

import { CF_NEU_BLD } from '../../../../shared/constants';

import './ServiceIdentityHeader.css';

interface ServiceIdentityHeaderProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

/**
 * Header for the Service Identity page, displaying the page title, an add button, and tab navigation.
 * @param props - The component props.
 * @param props.activeTab - The currently active tab value.
 * @param props.setActiveTab - Callback to update the active tab.
 * @returns The ServiceIdentityHeader component.
 */
function ServiceIdentityHeader({
  activeTab,
  setActiveTab,
}: ServiceIdentityHeaderProps) {
  const intl = useIntl();

  const handleChange = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <header className='ServiceIdentityHeader'>
      <div className='ServiceIdentityHeader-titleWrapper'>
        <Icon kind='Fingerprint' size='medium' />
        <Typography kind='h1' color={CF_NEU_BLD}>
          <FormattedMessage
            id='BfgNvS'
            defaultMessage='Non-Human Identities'
            description='Non-Human Identities title'
          />
        </Typography>
      </div>
      <TabGroup
        value={activeTab}
        onChange={handleChange}
        className='ServiceIdentityHeader-tabGroup'>
        {/* <TabItem
          label='All'
          value='1'
          icon={<Icon kind='UserManagement' size='medium' />}
        />
        <TabItem
          label='External'
          value='2'
          icon={<Icon kind='Workbench' size='medium' />}
        /> */}
        <TabItem
          label={intl.formatMessage({
            id: 'Egc/CQ',
            defaultMessage: 'Service Identity',
            description: 'Service Identity',
          })}
          value='3'
          icon={<Icon kind='ServiceAccount' size='medium' />}
        />
      </TabGroup>
    </header>
  );
}

export default ServiceIdentityHeader;
